import { render, staticRenderFns } from "./Page1.vue?vue&type=template&id=bd1360c4&scoped=true&"
import script from "./Page1.vue?vue&type=script&lang=js&"
export * from "./Page1.vue?vue&type=script&lang=js&"
import style0 from "./Page1.vue?vue&type=style&index=0&id=bd1360c4&prod&lang=css&"
import style1 from "./Page1.vue?vue&type=style&index=1&id=bd1360c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1360c4",
  null
  
)

export default component.exports